import { render, staticRenderFns } from "./SanadItemListReport.vue?vue&type=template&id=f12900ac&scoped=true&"
import script from "./SanadItemListReport.vue?vue&type=script&lang=js&"
export * from "./SanadItemListReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12900ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
